import React, { useState, useRef, Fragment } from "react"
import { Link } from "gatsby"
import {
  IconLogo,
  IconArrow,
  IconDropdownArrow,
  IconBurgerMenu,
  IconCross,
} from "./Icons"
import { Services } from "./services"
import "../styles/navbar.scss"
import { ButtonWithIcon } from "./buttonWithIcon"
import { StaticImage } from "gatsby-plugin-image"
// Navbar is translated here

const LANGUAGES = [
  { title: "PL", link: "/" },
  { title: "ENG", link: "/en/" },
]
const SERVICES = [
  {
    name: "Konsultacja ortopedyczna",
    link: "/konsultacja-ortopedyczna",
    children: [
      {
        name: "Diagnostyka i planowanie diagnostyki w chorobach układu ruchu",
        link: "/diagnostyka-i-planowanie-diagnostyki-w-chorobach-ukladu-ruchu",
      },
      {
        name: "Kontrola przed i po zabiegach ortopedycznych",
        link: "/kontrola-przed-i-po-zabiegach-ortopedycznych",
      },
      {
        name: "Ortezy i aparaty - skierowania refundowane przez NFZ",
        link: "/ortezy-i-aparaty-skierowania-refundowane-przez-nfz",
      },
    ],
  },
  { name: "USG stawów i mięśni", link: "/usg-miesni-i-stawow" },
  {
    name: "Inekcja i blokady",
    link: "/iniekcje-i-blokady",
    children: [
      {
        name: "Iniekcja sterydu (tzw. blokady)",
        link: "/iniekcja-sterydu",
      },
      {
        name: "Inekcja kwasu hialuronowego do stawu",
        link: "/iniekcja-kwasu-hialuronowego-do-stawu",
      },
      {
        name: "Inekcja PRP",
        link: "/iniekcja-prp",
      },
    ],
  },
  { name: "Zabiegi operacyjne (Szpital)", link: "/zabiegi-operacyjne" },
]

const SIDE_MENU_SERVICES = [
  {
    name: "Usługi",
    children: [
      {
        name: "Konsultacja ortopedyczna",
        link: "/konsultacja-ortopedyczna",
        bold: true,
      },
      {
        name: "Diagnostyka i planowanie diagnostyki w chorobach układu ruchu",
        link: "/diagnostyka-i-planowanie-diagnostyki-w-chorobach-ukladu-ruchu",
      },
      {
        name: "Kontrola przed i po zabiegach ortopedycznych",
        link: "/kontrola-przed-i-po-zabiegach-ortopedycznych",
      },
      {
        name: "Ortezy i aparaty - skierowania refundowane przez NFZ",
        link: "/ortezy-i-aparaty-skierowania-refundowane-przez-nfz",
      },
      { name: "USG stawów i mięśni", link: "/usg-miesni-i-stawow", bold: true },
      {
        name: "Inekcja i blokady",
        link: "/iniekcje-i-blokady",
        bold: true,
      },
      {
        name: "Iniekcja sterydu (tzw. blokady)",
        link: "/iniekcja-sterydu",
      },
      {
        name: "Inekcja kwasu hialuronowego do stawu",
        link: "/iniekcja-kwasu-hialuronowego-do-stawu",
      },
      {
        name: "Inekcja PRP",
        link: "/iniekcja-prp",
      },
      { name: "Zabiegi operacyjne (Szpital)", link: "/zabiegi-operacyjne" },
    ],
  },
  {
    name: "O mnie",
    link: "/o-mnie",
  },
  {
    name: "Ciekawe przypadki",
    link: "/ciekawe",
  },
  { name: "Aktualności", link: "/aktualnosci" },
  {
    name: "Kontakt",
    link: "/kontakt",
  },
]

export const Navbar = () => {
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false)
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false)
  const [sideMenuServicesDropdownOpen, setsideMenuServicesDropdownOpen] =
    useState(false)
  const [sideMenuOpen, setSideMenuOpen] = useState(false)
  const languageMenuRef = useRef(null)
  const languageButtonRef = useRef(null)

  const handleClickOutside = event => {
    if (
      languageMenuRef.current &&
      !languageMenuRef.current.contains(event.target) &&
      !languageButtonRef.current.contains(event.target)
    ) {
      setLanguageDropdownOpen(false)
    }
  }

  const switchLanguageDropdown = () => {
    setLanguageDropdownOpen(open => {
      if (!open) {
        document.addEventListener("click", handleClickOutside, true)
      } else {
        document.removeEventListener("click", handleClickOutside, true)
      }
      return !open
    })
  }

  const switchServiceDropdown = () => {
    setServicesDropdownOpen(open => !open)
  }

  const switchSideMenuServiceDropdown = () => {
    setsideMenuServicesDropdownOpen(open => !open)
  }

  const closeServiceDropdown = () => {
    setServicesDropdownOpen(false)
  }

  const openServiceDropdown = () => {
    setServicesDropdownOpen(true)
  }

  const switchSideMenuDrawer = () => {
    setSideMenuOpen(open => {
      if (!open) {
        document.body.style.overflow = "hidden"
      } else {
        document.body.style.overflow = "inherit"
      }
      return !open
    })
  }

  const closeSideMenu = () => {
    setSideMenuOpen(false)
    document.body.style.overflow = "inherit"
  }
  const closeSideMenuOnBackClick = event => {
    if (event.target === event.currentTarget) {
      setSideMenuOpen(open => !open)
      document.body.style.overflow = "inherit"
    }
  }

  return (
    <>
      <nav className="Navbar__wrapper">
        <div className="Navbar__main">
          <div className="Navbar__buttons">
            <div className="Navbar__icon">
              <Link to={"/"}>
                <IconLogo height={30} width={205} />
              </Link>
            </div>
            <ul className="Navbar__list">
              <li key={"list-services"} className="Navbar__list--element">
                <div
                  className="Navbar__services-button"
                  onClick={switchServiceDropdown}
                  onMouseEnter={openServiceDropdown}
                >
                  Usługi
                  <IconArrow
                    className={`Navbar__down-arrow-icon  ${
                      servicesDropdownOpen
                        ? "Navbar__down-arrow-icon--open"
                        : ""
                    }`}
                  ></IconArrow>
                </div>
              </li>
              <li key={"list-about"} className="Navbar__list--element">
                <Link activeClassName="active" to="/o-mnie">
                  O mnie
                </Link>
              </li>
              <li key={"list-cases"} className="Navbar__list--element">
                <Link activeClassName="active" to="/ciekawe">
                  Ciekawe przypadki
                </Link>
              </li>
              <li key={"list-news"} className="Navbar__list--element">
                <Link activeClassName="active" to="/aktualnosci">
                  Aktualności
                </Link>
              </li>
              <li key={"list-contact"} className="Navbar__list--element">
                <Link activeClassName="active" to="/kontakt">
                  Kontakt
                </Link>
              </li>
            </ul>
            <div className="Navbar__burger-wrapper">
              <div className="Navbar__burger" onClick={switchSideMenuDrawer}>
                <IconBurgerMenu className="Navbar__test"></IconBurgerMenu>
              </div>
              <div
                className={`Navbar__side-menu-wrapper ${
                  sideMenuOpen ? "Navbar__side-menu-wrapper--open" : ""
                }`}
                onClick={closeSideMenuOnBackClick}
              >
                <div className="Navbar__side-menu">
                  <div className="Navbar__side-menu-content-wrapper">
                    <div className="Navbar__side-menu-header">
                      <IconLogo height={25} width={170} />

                      <div
                        className="Navbar__side-menu-header-cross"
                        onClick={switchSideMenuDrawer}
                      >
                        <IconCross></IconCross>
                      </div>
                    </div>
                    <ul className="Navbar__side-menu-content">
                      {SIDE_MENU_SERVICES.map(service => {
                        if (!service.link) {
                          return (
                            <Fragment key={service.name}>
                              <li
                                key={service.name}
                                className="Navbar__side-menu-tile Navbar__side-menu-tile--dropdown  Navbar__side-menu-tile--underlined"
                                onClick={switchSideMenuServiceDropdown}
                              >
                                {service.name}
                                <IconArrow
                                  className={`Navbar__down-arrow-icon Navbar__down-arrow-icon--side-menu ${
                                    sideMenuServicesDropdownOpen
                                      ? "Navbar__down-arrow-icon--open"
                                      : ""
                                  }`}
                                ></IconArrow>
                              </li>
                              {service.children.map(child => (
                                <li
                                  key={child.link}
                                  className={`Navbar__side-menu-tile sub-item ${
                                    child.bold ? "bold" : ""
                                  } ${
                                    !sideMenuServicesDropdownOpen
                                      ? "Navbar__side-menu-tile--closed"
                                      : ""
                                  }`}
                                >
                                  <Link onClick={closeSideMenu} to={child.link}>
                                    {child.name}
                                  </Link>
                                </li>
                              ))}
                            </Fragment>
                          )
                        }

                        return (
                          <li
                            key={service.link}
                            className="Navbar__side-menu-tile Navbar__side-menu-tile--underlined"
                          >
                            <Link onClick={closeSideMenu} to={service.link}>
                              {service.name}
                            </Link>
                          </li>
                        )
                      })}
                      <li className="Navbar__side-menu--lang">
                        <Link onClick={closeSideMenu} to={"/en/"}>
                          <StaticImage
                            src="../../images/uk-flag.png"
                            alt="background"
                            quality={100}
                            width={40}
                            layout="fixed"
                          />
                        </Link>
                        <Link onClick={closeSideMenu} to={"/"}>
                          <StaticImage
                            src="../../images/pl-flag.png"
                            alt="background"
                            quality={100}
                            width={40}
                            layout="fixed"
                          />
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="Navbar__side-menu-footer">
                    <ButtonWithIcon
                      newTab={true}
                      link={
                        "https://mydr.pl/patient/new-visit/stationary?kind=Prywatna&doctor={%22id%22:54669,%22name%22:%22Marek+Kulczyk%22,%22search_id%22:%22b85c4a3fdb73f5%22}&search=true&location={%22place_name%22:%22Mielec%22,%22state_name%22:%22Subcarpathian+Voivodeship%22}"
                      }
                      className="Navbar__side-menu-footer-button"
                    >
                      <IconArrow className="Navbar__right-arrow-icon"></IconArrow>
                      Zarezerwuj wizytę
                    </ButtonWithIcon>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="Navbar__tools">
            <div className="Navbar__language">
              <button
                className="Navbar__language-button"
                onClick={switchLanguageDropdown}
                ref={languageButtonRef}
              >
                PL
                <IconDropdownArrow
                  className={`Navbar__dropdown-icon  ${
                    languageDropdownOpen ? "Navbar__dropdown-icon--open" : ""
                  }`}
                ></IconDropdownArrow>
              </button>
              <ul
                className={`Navbar__language-dropdown
            ${languageDropdownOpen ? "Navbar__language-dropdown--open" : ""}`}
                ref={languageMenuRef}
              >
                {LANGUAGES.map(language => (
                  <li
                    key={language.title}
                    className="Navbar__language-dropdown-element"
                  >
                    <Link
                      to={language.link}
                      className="Navbar__language-button-link"
                    >
                      {language.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <ButtonWithIcon
              newTab={true}
              link={
                "https://mydr.pl/patient/new-visit/stationary?kind=Prywatna&doctor={%22id%22:54669,%22name%22:%22Marek+Kulczyk%22,%22search_id%22:%22b85c4a3fdb73f5%22}&search=true&location={%22place_name%22:%22Mielec%22,%22state_name%22:%22Subcarpathian+Voivodeship%22}"
              }
            >
              <IconArrow className="Navbar__right-arrow-icon"></IconArrow>
              Zarezerwuj wizytę
            </ButtonWithIcon>
          </div>
        </div>
        <div
          className={`Navbar__services-dropdown  ${
            servicesDropdownOpen ? "Navbar__services-dropdown--open" : ""
          }`}
        >
          <Services
            handleClose={closeServiceDropdown}
            data={SERVICES}
          ></Services>
        </div>
      </nav>
    </>
  )
}
